import { Component, Input} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { AdvtService } from '../_services/advt.service';
import { AlertService } from '../_services/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Http } from '@angular/http';
import { NotificationsService} from 'angular2-notifications';




@Component({
  selector: 'app-rating-dialog',
  templateUrl: './rating-dialog.component.html',
  styleUrls: ['./rating-dialog.component.css']
})
export class RatingDialogComponent {
  public loading:Boolean = false;
  public mainLoader;
  public currentUser;  
  public comment;
  public rating: Number = 5;
  public buyer_id;
  public seller_id;
  public item_id;
  public emojiIcon;





 
  constructor(public modalRef: BsModalRef,
    private advtService: AdvtService,
    private alertService: AlertService,
    private http: Http,
    private route: ActivatedRoute,
    private _NotificationsService: NotificationsService,
    private router: Router, )  {}
 
  ngOnInit() {
    this.mainLoader = '../../assets/images/BigLoader.gif';

    const userInfo = JSON.parse(localStorage.getItem('currentUser'));
    this.currentUser = userInfo ? userInfo.result : null;
    this.emojiCheck();
  }

  _disposeModal(){
    this.modalRef.hide()
  }

  public rateSeller(currentUser) {
    // this.advtService.getUserInfoId(this.currentUser.id).subscribe(res => {
    // });
    

    // const userInfo = JSON.parse(localStorage.getItem('currentUser'));
    // this.currentUser = userInfo ? userInfo.result : null;

      if(this.currentUser){
        this.loading = true;
        const params = {
          buyer_id: this.currentUser.id,
          item_id: this.item_id,
          seller_id: this.currentUser.rating_against_seller,
          rating: this.rating ? this.rating : 5,
          comment: this.comment,
        }
        this.advtService.rateSeller(params).subscribe(res => {
         if(res.status == 200){
          let ratingCheck = JSON.parse(localStorage.getItem('currentUser'));
          ratingCheck.result.rating_pending = 0;
          ratingCheck.result.rating_against_seller = 0;
          localStorage.setItem("currentUser", JSON.stringify(ratingCheck));
          // this.router.navigate(['/dashboard']);
         }
         else{
           this._NotificationsService.warn("You have already rated on this item")
         }
         });
      }


     this._disposeModal();
    this.loading = false;

  }

  public emojiCheck(){
    if(this.rating === 1 ){
      this.emojiIcon = '../assets/images/one.png';
    }else if(this.rating === 2){
      this.emojiIcon = '../assets/images/two.png';
    }else if(this.rating === 3){
      this.emojiIcon = '../assets/images/three.png';
    }else if(this.rating === 4){
      this.emojiIcon = '../assets/images/four.png';
    }else if(this.rating === 5){
      this.emojiIcon = '../assets/images/five.png';
    }
  }

} 


// WEBPACK FOOTER //
// ./src/app/rating-dialog/rating-dialog.component.ts